/*
			 _
 _____ ___ _| |
|     | . | . |
|_|_|_|___|___|

"mod" aka Modular Omegatron Destructobot, is a modular code framework
for simple JavaScript applications. It starts small, but much like Voltron
before it, mod will cut your breastplate with a firey flamberge.

*/

(function (window, document, undefined) {
	"use strict";

	var config = {

		// Determine which console functions we want to override
		logFns: ["log", "debug", "warn", "error", "time", "timeEnd"],

		// Define a "no operation" function
		noop: function () { }

	};

	window.mod = {

		// Determine if we're debbuging
		isDebug: (window.location.href.toLowerCase().indexOf("..showdebuginfo..=on") !== -1 || !!window.Debug),

		// Determines whether a node exists in the DOM (zombie reference)
		nodeExists: function (el) {
			if (el) {
				while (el = el.parentNode) {
					if (el === document) {
						return true;
					}
				}
			}

			return false;
		}

	};

	// Give ourselves replacements for the console functions that only run when debugging
	for (var i = config.logFns.length - 1; i >= 0; i--) {
		var fnName = config.logFns[i];

		// Create a safe version of the function
		if (!window.console || !fnName in console) {
			window.console = window.console || {};
			console[fnName] = config.noop;
		}

		// Give us a wrapper for the console that only runs when we're debugging
		mod[fnName] = function () {
			if (mod.isDebug && typeof (console[fnName]) === "function") {
				console[fnName].apply(console, Array.prototype.slice.call(arguments));
			}
		}
	}

	mod.timer = function (name) {
		if (mod.isDebug) {
			this.archive = this.archive || {};
			this.running = this.running || {};

			// Start
			if (!this.running[name]) {
				this.running[name] = new Date();
			}
			// Stop
			else {
				var durationMs = new Date().getTime() - this.running[name].getTime();
				delete this.running[name];

				if (!this.archive[name]) {
					this.archive[name] = {
						avg: 0,
						min: 0,
						max: 0,
						runs: []
					};
				}

				this.archive[name].runs.push(durationMs);
				this.archive[name].min = Math.min.apply(Math, this.archive[name].runs);
				this.archive[name].max = Math.max.apply(Math, this.archive[name].runs);

				this.archive[name].avg = (function (collection) {
					var total = 0;

					for (var i = collection.length - 1; i >= 0; i--) {
						total += collection[i];
					}

					return total / collection.length;
				})(this.archive[name].runs);

				mod.log(name + ":", durationMs + "ms", this.archive[name]);
			}
		}
	};

	mod.timerIf = function (condition, name) {
		if (condition) {
			mod.timer(name);
		}
	};



	mod.cookies = {
	    getItem: function (sKey) {
	        if (!sKey) { return null; }
	        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
	    },
	    setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
	        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
	        var sExpires = "";
	        if (vEnd) {
	            switch (vEnd.constructor) {
	                case Number:
	                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
	                    break;
	                case String:
	                    sExpires = "; expires=" + vEnd;
	                    break;
	                case Date:
	                    sExpires = "; expires=" + vEnd.toUTCString();
	                    break;
	            }
	        }
	        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
	        return true;
	    },
	    removeItem: function (sKey, sPath, sDomain) {
	        if (!this.hasItem(sKey)) { return false; }
	        document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
	        return true;
	    },
	    hasItem: function (sKey) {
	        if (!sKey) { return false; }
	        return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
	    },
	    keys: function () {
	        var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
	        for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
	        return aKeys;
	    }
	};

    //testing
    //mod.cookies.setItem('vlmodql', 'productcode=BR9201,BR0100,2ETFW,2CONVERT,MA1,2M1,BP0050');

})(window, document);